import {
  IonButton,
  IonContent,
  IonInput,
  IonItem,
  IonLabel,
  IonModal,
} from "@ionic/react";
import "./SBoardCalculator.scss";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
interface ContainerProps {
  showModal: boolean;
  onCancel: () => void;
}

const SBoardCalculator: React.FC<ContainerProps> = (props) => {
  const { t } = useTranslation("statusBoard");
  let message: any = "";
  let result: any = "";

  const [data, setData]: any = useState([]);
  const [errorMessage, setErrorMessage]: any = useState("");
  const [disableBtn, setDisableBtn]: any = useState(false);

  const btnClicked = (btn: any) => {
    message = "";
    if (btn === "AC") {
      result = "";
      setDisableBtn(false);
      setErrorMessage("");
      setData(result);
    } else if (btn === "=") {
      result = evaluation(data);
      setData(result);
    } else if (btn === "C") {
      try {
        return setData(data.substr(0, data.length - 1));
      } catch (e) {
        if (e instanceof SyntaxError) {
          message = t("invalidEntry");
          setErrorMessage(message);
          setDisableBtn(true);
        }
      }
    } else {
      result += btn;
      var calculatedResult = data + result;
      setData(calculatedResult);
    }
  };

  const evaluation = (dataAsArray: any) => {
    try {
      return eval(dataAsArray);
    } catch (e) {
      if (e instanceof SyntaxError) {
        message = t("invalidEntry");
        setErrorMessage(message);
        setDisableBtn(true);
      }
    }
  };

  return (
    <IonModal
      isOpen={props.showModal}
      backdropDismiss={false}
      className="calculator-modal"
    >
      <div className="calculator-header"> 
      <div>
          <div
            className="close icon-close"
            onClick={() => props.onCancel()}
            padding-right
          ></div>
        </div>
        <IonLabel className="calculator">{t("calculator")}</IonLabel>

       
      </div>
      <IonContent>
        <form id="calculator-form">
          <IonItem className="calculator-input">
            <IonInput id="inputSec" placeholder="0" name="display" readonly>
              {data}
            </IonInput>
          </IonItem>
        </form>
        <div className="error-msg">{errorMessage}</div>
        <div id="calculator-main-container">
          <div className="calc-first-container">
            <IonButton
              className="calc-btn-1 button secondary-transparent-btn btn-curved"
              onClick={() => btnClicked("AC")}
            >
              AC
            </IonButton>
            <IonButton
              className="calc-btn-2 button secondary-transparent-btn btn-curved"
              disabled={disableBtn}
              onClick={(e) => btnClicked("/")}
              defaultValue="/"
            >
              /
            </IonButton>
          </div>

          <div className="calc-sec-container">
            <IonButton
              className="calc-btn-3 button secondary-transparent-btn btn-curved"
              disabled={disableBtn}
              onClick={(e) => btnClicked("7")}
            >
              7
            </IonButton>
            <IonButton
              className="calc-btn-3 button secondary-transparent-btn btn-curved"
              disabled={disableBtn}
              onClick={(e) => btnClicked("8")}
            >
              8
            </IonButton>
            <IonButton
              className="calc-btn-3 button secondary-transparent-btn btn-curved"
              disabled={disableBtn}
              onClick={(e) => btnClicked("9")}
            >
              9
            </IonButton>
            <IonButton
              className="calc-btn-3 button secondary-transparent-btn btn-curved"
              disabled={disableBtn}
              onClick={(e) => btnClicked("*")}
              defaultValue="*"
            >
              X
            </IonButton>
          </div>

          <div className="calc-third-container">
            <IonButton
              className="calc-btn-3 button secondary-transparent-btn btn-curved"
              disabled={disableBtn}
              onClick={(e) => btnClicked("4")}
            >
              4
            </IonButton>
            <IonButton
              className="calc-btn-3 button secondary-transparent-btn btn-curved"
              disabled={disableBtn}
              onClick={(e) => btnClicked("5")}
            >
              5
            </IonButton>
            <IonButton
              className="calc-btn-3 button secondary-transparent-btn btn-curved"
              disabled={disableBtn}
              onClick={(e) => btnClicked("6")}
            >
              6
            </IonButton>
            <IonButton
              className="calc-btn-3 button secondary-transparent-btn btn-curved"
              disabled={disableBtn}
              onClick={(e) => btnClicked("-")}
              defaultValue="-"
            >
              -
            </IonButton>
          </div>

          <div className="calc-fourth-container">
            <IonButton
              className="calc-btn-3 button secondary-transparent-btn btn-curved"
              disabled={disableBtn}
              onClick={(e) => btnClicked("1")}
            >
              1
            </IonButton>
            <IonButton
              className="calc-btn-3 button secondary-transparent-btn btn-curved"
              disabled={disableBtn}
              onClick={(e) => btnClicked("2")}
            >
              2
            </IonButton>
            <IonButton
              className="calc-btn-3 button secondary-transparent-btn btn-curved"
              disabled={disableBtn}
              onClick={(e) => btnClicked("3")}
            >
              3
            </IonButton>
            <IonButton
              className="calc-btn-3 button secondary-transparent-btn btn-curved"
              disabled={disableBtn}
              onClick={(e) => btnClicked("+")}
              defaultValue="+"
            >
              +
            </IonButton>
          </div>

          <div className="calc-fifth-container">
            <IonButton
              className="calc-btn-3 button secondary-transparent-btn btn-curved"
              disabled={disableBtn}
              onClick={(e) => btnClicked("C")}
            >
              C
            </IonButton>
            <IonButton
              className="calc-btn-3 button secondary-transparent-btn btn-curved"
              disabled={disableBtn}
              onClick={(e) => btnClicked("0")}
            >
              0
            </IonButton>
            <IonButton
              className="calc-btn-3 button secondary-transparent-btn btn-curved"
              disabled={disableBtn}
              onClick={(e) => btnClicked(".")}
              defaultValue="."
            >
              .
            </IonButton>
            <IonButton
              className="calc-btn-3 button secondary-transparent-btn btn-curved"
              disabled={disableBtn}
              onClick={(e) => btnClicked("=")}
              defaultValue="="
            >
              =
            </IonButton>
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
};

export default SBoardCalculator;
